/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Nudge_TextInputs */

const en_install_nudge_text = /** @type {((inputs: Install_Nudge_TextInputs) => LocalizedString) & { parts: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Install_Nudge_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Use OpenRift like an app. Add it to your home screen.`)
		}),
		{
			parts: /** @type {(inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "b", options: {}, attributes: {} }, { type: "text", value: "Use OpenRift like an app." }, { type: "markup-end", name: "b", options: {}, attributes: {} }, { type: "text", value: " Add it to your home screen." }])
			})
		}
	)
);

const de_install_nudge_text = /** @type {((inputs: Install_Nudge_TextInputs) => LocalizedString) & { parts: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Install_Nudge_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Nutze OpenRift wie eine App. Leg es auf deinen Home-Bildschirm.`)
		}),
		{
			parts: /** @type {(inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "b", options: {}, attributes: {} }, { type: "text", value: "Nutze OpenRift wie eine App." }, { type: "markup-end", name: "b", options: {}, attributes: {} }, { type: "text", value: " Leg es auf deinen Home-Bildschirm." }])
			})
		}
	)
);

const fr_install_nudge_text = /** @type {((inputs: Install_Nudge_TextInputs) => LocalizedString) & { parts: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Install_Nudge_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Utilisez OpenRift comme une app. Ajoutez-le à votre écran d'accueil.`)
		}),
		{
			parts: /** @type {(inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "b", options: {}, attributes: {} }, { type: "text", value: "Utilisez OpenRift comme une app." }, { type: "markup-end", name: "b", options: {}, attributes: {} }, { type: "text", value: " Ajoutez-le à votre écran d'accueil." }])
			})
		}
	)
);

const zh_hans1_install_nudge_text = /** @type {((inputs: Install_Nudge_TextInputs) => LocalizedString) & { parts: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Install_Nudge_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`像 App 一样使用 OpenRift。把它添加到主屏幕。`)
		}),
		{
			parts: /** @type {(inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "b", options: {}, attributes: {} }, { type: "text", value: "像 App 一样使用 OpenRift。" }, { type: "markup-end", name: "b", options: {}, attributes: {} }, { type: "text", value: "把它添加到主屏幕。" }])
			})
		}
	)
);

const zh_hant1_install_nudge_text = /** @type {((inputs: Install_Nudge_TextInputs) => LocalizedString) & { parts: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Install_Nudge_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`像 App 一樣使用 OpenRift。把它加入主畫面。`)
		}),
		{
			parts: /** @type {(inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "b", options: {}, attributes: {} }, { type: "text", value: "像 App 一樣使用 OpenRift。" }, { type: "markup-end", name: "b", options: {}, attributes: {} }, { type: "text", value: "把它加入主畫面。" }])
			})
		}
	)
);

const ko_install_nudge_text = /** @type {((inputs: Install_Nudge_TextInputs) => LocalizedString) & { parts: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Install_Nudge_TextInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`OpenRift를 앱처럼 사용하세요. 홈 화면에 추가해 보세요.`)
		}),
		{
			parts: /** @type {(inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "b", options: {}, attributes: {} }, { type: "text", value: "OpenRift를 앱처럼 사용하세요." }, { type: "markup-end", name: "b", options: {}, attributes: {} }, { type: "text", value: " 홈 화면에 추가해 보세요." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Use OpenRift like an app. Add it to your home screen." |
*
* @param {Install_Nudge_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const install_nudge_text = /** @type {((inputs?: Install_Nudge_TextInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & { parts: (inputs?: Install_Nudge_TextInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Install_Nudge_TextInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, { b: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Install_Nudge_TextInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "de") return de_install_nudge_text(inputs)
			if (locale === "fr") return fr_install_nudge_text(inputs)
			if (locale === "zh-Hans") return zh_hans1_install_nudge_text(inputs)
			if (locale === "zh-Hant") return zh_hant1_install_nudge_text(inputs)
			if (locale === "ko") return ko_install_nudge_text(inputs)
			return en_install_nudge_text(inputs)
		}),
		{
			parts: /** @type {(inputs?: Install_Nudge_TextInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "de") return /** @type {{ parts?: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (de_install_nudge_text).parts?.(inputs) ?? [{ type: "text", value: de_install_nudge_text(inputs) }]
				if (locale === "fr") return /** @type {{ parts?: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (fr_install_nudge_text).parts?.(inputs) ?? [{ type: "text", value: fr_install_nudge_text(inputs) }]
				if (locale === "zh-Hans") return /** @type {{ parts?: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (zh_hans1_install_nudge_text).parts?.(inputs) ?? [{ type: "text", value: zh_hans1_install_nudge_text(inputs) }]
				if (locale === "zh-Hant") return /** @type {{ parts?: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (zh_hant1_install_nudge_text).parts?.(inputs) ?? [{ type: "text", value: zh_hant1_install_nudge_text(inputs) }]
				if (locale === "ko") return /** @type {{ parts?: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (ko_install_nudge_text).parts?.(inputs) ?? [{ type: "text", value: ko_install_nudge_text(inputs) }]
				return /** @type {{ parts?: (inputs: Install_Nudge_TextInputs) => import('../runtime.js').MessagePart[] }} */ (en_install_nudge_text).parts?.(inputs) ?? [{ type: "text", value: en_install_nudge_text(inputs) }]
			})
		}
	)
);